import { barrierColor, dashArray, dataForBarriers } from "../../charts/D3Chart";
import { line as lineD3 } from "d3";
import { dateInterpolate } from "@/_core/charts/D3ChartHoverHelpers";

export class Scatter {
  constructor(svg, svgAux = null) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
    this.context = this;
  }

  createLine(allData) {
    return lineD3()
      .defined(d => d.y)
      .x(d =>
        dateInterpolate(
          allData.xRange,
          d[allData.dateFld],
          this.context.svg.x,
          this.context.svg.x.bandwidth()
        )
      )
      .y(d => this.context.svg.y(d.y));
  }

  updateStickElement(
    enter,
    customName,
    customNameDash,
    line,
    isUpdate = false
  ) {
    const isEnter = isUpdate ? enter : enter.append("path");

    return isEnter
      .style("stroke", barrierColor(customName, true))
      .style("stroke-width", 1)
      .attr("class", "sticks" + customName)
      .style("stroke-dasharray", dashArray(customNameDash))
      .attr("d", d => line(d.values))
      .style("shape-rendering", "crispEdges")
      .style("vector-effect", "non-scaling-stroke");
  }

  handleSticks(allData, checkCondition, getData) {
    const line = this.createLine(allData);

    allData.dataSticks.forEach(obj => {
      obj.showFields.forEach((field, i) => {
        if (checkCondition(field)) {
          let containerGroup = this.context.svg[obj.customName[i] + "Stick"];

          if (containerGroup) {
            const newData = dataForBarriers(
              getData(obj, i) || allData.barrierData,
              allData.dateFld
            );

            this.context.svg[obj.customName[i] + "Stick"] = this.context.svg[
              obj.customName[i] + "Stick"
            ]
              .data(newData.series)
              .join(
                enter =>
                  this.updateStickElement(
                    enter,
                    obj.customName[i],
                    obj.customNameDash[i],
                    line
                  ),
                update =>
                  this.updateStickElement(
                    update,
                    obj.customName[i],
                    obj.customNameDash[i],
                    line,
                    true
                  ),
                exit => exit.remove()
              );
          }
        }
      });
    });
  }

  handleRects(allData, checkCondition) {
    allData.dataRect.forEach(obj => {
      obj.showFields.forEach((field, i) => {
        if (checkCondition(field)) {
          const containerElement = this.context.svg[obj.customName[i] + "Rect"];
          if (containerElement) {
            containerElement
              .selectAll("rect")
              .data(allData.barrierData)
              .join(
                enter =>
                  enter
                    .append("rect")
                    .attr("y", d => this.context.svg.y(d.barrier) - 2),
                update =>
                  update.attr("y", d => this.context.svg.y(d.barrier) - 2),
                exit => exit.remove()
              );
          }
        }
      });
    });
  }

  scatterBarriers(_this, allData, isOld = false) {
    const checkCondition = isOld
      ? field => _this[field]
      : field => _this.Analytics["userSelections"][field];

    const getData = isOld ? () => allData.barrierData : (obj, i) => obj.data[i];

    this.handleSticks(allData, checkCondition, getData);
    this.handleRects(allData, checkCondition);
  }

  scattersZoom(_this, allData) {
    allData.forEach(obj => {
      if (!_this.Analytics["userSelections"][obj.isShow]) {
        obj.showFields.forEach((field, i) => {
          if (_this.Analytics["userSelections"][field]) {
            this.context.svg[obj.customName[i]]
              .selectAll("image")
              .data(obj.dataHv[i])
              .join(
                enter =>
                  enter
                    .append("image")
                    .attr("y", d => this.context.svg.y(d.strike)),
                update => update.attr("y", d => this.context.svg.y(d.strike)),
                exit => exit.remove()
              );
          }
        });
      }
    });
  }

  scattersOld(_this, allData) {
    allData.forEach(obj => {
      obj.showFields.forEach((field, i) => {
        if (_this[field]) {
          this.context.svg[obj.customName[i]]
            .selectAll("image")
            .data(obj.dataHv[i])
            .join(
              enter =>
                enter
                  .append("image")
                  .attr("y", d => this.context.svg.y(d.strike)),
              update => update.attr("y", d => this.context.svg.y(d.strike)),
              exit => exit.remove()
            );
        }
      });
    });
  }
}
